export default {
  getIsLoading: state => state.isLoading,
  getParent: state => state.folder,
  getFolder: state => state.folder,
  getFolders: state => state.folders,
  getMovingState: state => state.moving.state,
  getMovingType: state => state.moving.folder,
  getMovingElements: state => state.moving.elements,
}
